import styled from 'styled-components'
import { colors } from '../../assets/colors'

export const Label = styled.span`
  font-size: 14px;
  color: ${colors.mediumGrey};
  margin: 10px;
`
